import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { setPayHistory } from "../../../../infra/aggregates/myProfile/salaryAggregates/payHistorySlice";

import { salaryService } from "../../../../api/services/salaryService";
import { setPayHistoryLoader } from "../../../../infra/aggregates/myProfile/salaryAggregates/salaryLoadersSlice";
import { userService } from "../../../../api/services/userService";
import { setEmployeeCompanyData } from "../../../../infra/aggregates/employeeCompanySlice";

interface PropsValues {
  setPayHistoryData: (data: any) => void;
  yearFilter: number;
  setCurrency: (data: any) => void;
}

function DTOPayHistory({
  setPayHistoryData,
  yearFilter,
  setCurrency,
}: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);

  const dispatch = useAppDispatch();

  async function getEmpPayHistory(empId: number, companyId: number) {
    dispatch(setPayHistoryLoader(true));

    const response: any = await salaryService.getPayHistory(empId, companyId);

    if (response.response == "success") {
      dispatch(setPayHistory(response.data));
      setPayHistoryData(response.data);
      setCurrency(selector.currency);
      dispatch(setPayHistoryLoader(false));
    } else {
      dispatch(setPayHistoryLoader(false));

      return;
    }
  }
  async function getCompanyLogo(companyId: any) {
    await userService
      .getCompanDetail(companyId)
      .then((response: any) => {
        if (response.response == "success") {
          dispatch(setEmployeeCompanyData({ logo: response?.data?.logo }));
        }
      })
      .catch((err) =>
        console.log("error while getting company detail for employee", err)
      );
  }
  useEffect(() => {
    getCompanyLogo(selector.company_id);
    getEmpPayHistory(selector.emp_id, selector.company_id);
  }, []);

  async function getPayHistoryList(
    empId: number,
    companyID: number,
    year: number
  ) {
    dispatch(setPayHistoryLoader(true));

    const response = await salaryService.getPayHistoryWithYear(
      empId,
      companyID,
      year
    );
    if (response?.response === "success") {
      dispatch(setPayHistory(response.data));
      setPayHistoryData(response.data);
      dispatch(setPayHistoryLoader(false));
    } else {
      dispatch(setPayHistoryLoader(false));
      return;
    }
  }

  useEffect(() => {
    if (yearFilter != 0) {
      getPayHistoryList(selector.emp_id, selector.company_id, yearFilter);
    }
  }, [yearFilter]);

  return <></>;
}
export default DTOPayHistory;
